<script>
import MUILoader from '../MUILoader/MUILoader.vue';
import { muiLoaderFullPage } from './config';

export default {
  name: 'mui-loader-full-page',

  components: {
    MUILoader
  },

  props: muiLoaderFullPage.props,

  watch: {

    /**
     * It handles the body scroll behavior whenever the component
     * is visible or not.
     *
     * @param {Boolean} newValue - The current state of the loader
     *
     * @returns {void}
     */
    isActive(newValue) {
      this.setOverflow(newValue)
    }
  },

  created() {
    if (this.isActive) {
      this.setOverflow(this.isActive)
    }
  },

  methods: {
    setOverflow(isActive) {
      if (isActive){
        if (document.body.scrollHeight > window.innerHeight) {
          document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
        }

        document.body.classList.add('overflow-hidden');

        return;
      }

      document.body.style.paddingRight = '0px';
      document.body.classList.remove('overflow-hidden');
    }
  },
};
</script>

<template>
  <Transition name="fade">
    <div class="mui-loader-full-page" v-show="isActive">
      <MUILoader
        :diameter='diameter'
        :percentage='percentage'
        :border='border'
        :border-color='borderColor'
        :background-color='backgroundColor'
      />
      <span
        v-if="loadingMessage"
        class="mui-loader-full-page__message"
      >
        {{ loadingMessage }}
      </span>
    </div>
  </Transition>
</template>

<style lang="stylus" scoped>
@import '~commons/stylus/core/_vars'

.mui-loader-full-page
  display flex
  flex-direction column
  align-items center
  justify-content center
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  width 100vw
  height 100vh
  background-color rgba($brightGray, .8)
  z-index 9999
  cursor wait

  &__message
    display block
    margin-top 16px
    font-size 16px
    line-height 20px
    color White
</style>
